import { useEffect } from "react";

export default function usePageTitle(title) {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} · GESL Spinners Limited`;
    window.scrollTo({ top: 0, behavior: "instant" });
    return () => { document.title = prev; };
  }, [title]);
}
